import React, { useContext, useEffect, useState } from 'react';

import CommonPopup from 'components/CommonPopup';
import { TABS_MAPPING } from 'components/NavigationBarAndDrawer/LanguageSelectionPopup/constant';
import { AccountContext } from 'providers/accountProvider';
import { put } from 'lib/api';
import { handleNewEventLog } from 'lib/utils/events';
import { Loader } from 'designSystem/components/common2/ui2/Loader/styles';
import ICONOGRAPHY from 'designSystem/icons/strokeIcons';

import * as Styles from './styles';

const { book: BookIcon, 'new-headphone': NewHeadphoneIcon } = ICONOGRAPHY;

const LanguageSelectionPopup = ({ isVisible, close, localisationData }) => {
  const [selectedTab, setSelectedTab] = useState('');
  const { user } = useContext(AccountContext);

  useEffect(() => {
    if (!selectedTab) setSelectedTab(localisationData?.content_format);
  }, [localisationData]);

  const [currentSelectedLanguage, setCurrentSelectedLanguage] = useState(null);
  const [selectedLanguageTab, setSelectedLanguage] = useState('');
  const { onUpdateUser } = useContext(AccountContext);

  async function handleLanguageClick(selectedLanguage) {
    handleNewEventLog(
      'writer_home',
      'writer_home_format_selection_popup_language_selected',
      {
        module_name: 'writer_home',
      },
      user
    );
    try {
      setCurrentSelectedLanguage(selectedLanguage);
      const res = await put('/localisation/creators/', 'v3', {
        data: {
          content_format: selectedTab,
          language: selectedLanguage,
        },
      });
      if (res.status === 'success') {
        setSelectedLanguage(res.data.updated_language);
        localStorage.setItem(
          'content_format_language',
          res.data.updated_language
        );
        localStorage.setItem('content_format', selectedTab);
        onUpdateUser();
        close();
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setCurrentSelectedLanguage(null);
    }
  }

  function handleContentFormatTabClick(eachTab) {
    setSelectedTab(eachTab);
    handleNewEventLog(
      'writer_home',
      'writer_home_format_selection_popup_format_selected',
      {
        module_name: 'writer_home',
      },
      user
    );
  }

  return (
    <CommonPopup isOpen={isVisible} onClose={close}>
      <div className="v-d-flex center">
        {localisationData?.available_formats?.length > 1 && (
          <>
            <Styles.Heading>What you want to create?</Styles.Heading>
            <Styles.SubHeading>
              Choose the format of the creation.
            </Styles.SubHeading>
            <Styles.TabSelection>
              {TABS_MAPPING.map((eachTab) => (
                <Styles.EachTab
                  key={eachTab.id}
                  isActive={selectedTab === eachTab.id}
                  onClick={() => handleContentFormatTabClick(eachTab.id)}
                  className="cursor-pointer"
                >
                  {eachTab.id === 'novel' ? (
                    <BookIcon
                      fill={selectedTab === eachTab.id ? '#FFFFFF' : '#078AE2'}
                    />
                  ) : (
                    <NewHeadphoneIcon
                      fill={selectedTab === eachTab.id ? '#FFFFFF' : '#078AE2'}
                    />
                  )}
                  <Styles.EachTabLabel isActive={selectedTab === eachTab.id}>
                    {eachTab.label}
                  </Styles.EachTabLabel>
                </Styles.EachTab>
              ))}
            </Styles.TabSelection>
            <Styles.DottedLine />
          </>
        )}
        <Styles.LanguageSelection className="v-center">
          <Styles.Heading>In which language you want to create?</Styles.Heading>
          <Styles.SubHeading>
            {`Choose the language in which you want to write down your ${selectedTab}`}
            .
          </Styles.SubHeading>
        </Styles.LanguageSelection>
        <Styles.LanguageTabs className="v-d-flex">
          {localisationData?.available_languages[selectedTab]?.map(
            (eachLanguage) => (
              <Styles.EachLanguageTab
                key={eachLanguage}
                className="cursor-pointer"
                onClick={() => handleLanguageClick(eachLanguage)}
                isActive={selectedLanguageTab === eachLanguage}
              >
                {currentSelectedLanguage === eachLanguage ? (
                  <Loader color="#078AE2" />
                ) : (
                  eachLanguage
                )}
              </Styles.EachLanguageTab>
            )
          )}
        </Styles.LanguageTabs>
      </div>
    </CommonPopup>
  );
};

export default LanguageSelectionPopup;
